// extracted by mini-css-extract-plugin
module.exports = {"destination":"Button_destination__2p2aO","basic":"Button_basic__1OTjf","primary":"Button_primary__f6rbx","secondary":"Button_secondary__18pCA","cancel":"Button_cancel__9NuUx"};